export class PropertyPriceCalculator {
    constructor(properties) {
      this.properties = properties || [];
      this.calculatedPrices = new Map();
      this.formValues = {};
    }
  
    setFormValues(wizardData) {
      const result = {};
      
      const processFields = (fields) => {
        fields.forEach(field => {
          if (field.value !== undefined && field.value !== '') {
            result[field.id] = field.value;
          }
          if (field.fields && Array.isArray(field.fields)) {
            processFields(field.fields);
          }
        });
      };
  
      wizardData.wizardSteps.forEach(step => {
        if (step.fields) {
          processFields(step.fields);
        }
      });
  
      this.formValues = result;
    }
  
    evaluatePriceEquation(equation) {
      // Prepare the equation with function wrapper
      let fullEquation = 'function calculateCost() {\n';
      
      // Add form values as variables
      Object.entries(this.formValues).forEach(([key, value]) => {
        // Handle different types of values
        if (Array.isArray(value)) {
          fullEquation += `const ${key} = ${JSON.stringify(value)};\n`;
        } else if (typeof value === 'string') {
          fullEquation += `const ${key} = "${value}";\n`;
        } else {
          fullEquation += `const ${key} = ${value};\n`;
        }
      });
  
      // Add the actual price equation
      fullEquation += equation;
      fullEquation += "\n}";
      //console.log("Full equation:", fullEquation);
      try {
        const scriptFunction = new Function(fullEquation + ` return calculateCost();`);
        const result = scriptFunction();
        return parseFloat(result.toFixed(2));
      } catch (error) {
        console.error("Error in calculating cost:", error);
        console.error("Equation:", fullEquation);
        console.error("Form values:", this.formValues);
        return 0;
      }
    }
  
    calculatePriceForStep(step) {
        if (!step.fields) return [];
    
        const stepPrices = [];
    
        step.fields.forEach(field => {
          if (field.dataType !== 'CheckboxSelection' && field.dataType !== 'RadioSelection') return;
          if (!field.value) return;
    
          let selectedOptions = [];
          const fieldPriceDetails = [];
          let fieldTotal = 0;
    
          // Get selected options based on field type
          if (field.dataType === 'CheckboxSelection') {
            selectedOptions = field.options.filter(opt => 
              Array.isArray(field.value) && field.value.includes(opt.label)
            );
          } else { // RadioSelection
            selectedOptions = field.options.filter(opt => opt.label === field.value);
          }
    
          // Calculate prices for each selected option
          selectedOptions.forEach(option => {
            if (!option.properties || !Array.isArray(option.properties)) return;
    
            option.properties.forEach(optionProperty => {
              const originalProperty = this.properties.find(
                prop => prop.id === optionProperty.id
              );
    
              if (originalProperty?.isPricing) {
                const price = this.evaluatePriceEquation(
                  originalProperty.priceEquation
                );
    
                fieldTotal += price;
                fieldPriceDetails.push({
                  optionLabel: option.label,
                  propertyId: originalProperty.id,  // Include property ID
                  propertyLabel: originalProperty.label,
                  price,
                });
              }
            });
          });
    
          if (fieldPriceDetails.length > 0) {
            stepPrices.push({
              fieldId: field.id,
              fieldLabel: field.label,
              total: fieldTotal,
              details: fieldPriceDetails
            });
          }
        });
    
        return stepPrices;
      }
  
    calculateAllPrices(wizardData) {
      // First update form values
      this.setFormValues(wizardData);
      
      let allPrices = [];
      
      wizardData.wizardSteps.forEach(step => {
        const stepPrices = this.calculatePriceForStep(step);
        allPrices = [...allPrices, ...stepPrices];
      });
  
      return allPrices;
    }
  }
  
  export default PropertyPriceCalculator;